import { serializeToQueryString } from "@/shared/helpers";

export function phoneCleaner(phoneNumberString: string) {
    return phoneNumberString ? String(phoneNumberString).replace(/\D/g, '') : ''
}
export function whatsappURL(phoneNumberString: string, message?: string) {
    let ddi = '55';
    let phoneNumberRest;

    if(phoneNumberString.startsWith('+')){
        [ddi, ...phoneNumberRest] = phoneNumberString.split(' ');
    }

    const phoneNumberStringFormatted = phoneNumberRest ? phoneNumberRest.join('') : phoneNumberString;
    const phone = ddi + phoneCleaner(phoneNumberStringFormatted);

    const params = {
        text: message ?? "Olá, estou entrando em contato pelo site!",
        phone,
    };

    return `https://api.whatsapp.com/send?${serializeToQueryString(params)}`;
}
